import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { first, catchError, mergeMap } from 'rxjs/operators';

import { LoginService } from '@core/services/login.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private loginService: LoginService, private activatedRoute: ActivatedRoute) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let nextRequest = request;
    const ignoreURLs = nextRequest.url.indexOf('assets') >= 0 || nextRequest.url.indexOf('login') >= 0;
    if (!ignoreURLs) {
      nextRequest = this.setRequestHeadersIfNotHasAuthorization(request);
    }
    return next.handle(nextRequest).pipe(
      catchError(httpError => {
        if (httpError.status === 0 || httpError.status === 401) {
          if (!ignoreURLs) {
            return this.loginService
              .refreshAgentTokens()
              .pipe(first())
              .pipe(
                mergeMap((loginResponse: { accessToken: string; refreshToken: string }) => {
                  const requestWithNewHeaders = this.setRequestHeadersWithNewTokens(nextRequest);
                  return next.handle(requestWithNewHeaders);
                }),
                catchError((error: HttpEvent<any>) => {
                  this.checkResponseErrors(error);
                  return throwError(error);
                })
              );
          }
          if (nextRequest.url.indexOf('tokens') >= 0) {
            this.loginService.onLogout();
            this.redirectUser();
            return throwError(nextRequest);
          }
        }
        return throwError(httpError);
      })
    );
  }

  private setRequestHeadersIfNotHasAuthorization(request: HttpRequest<any>): HttpRequest<any> {
    if (!request.headers.has('Authorization')) {
      return this.setRequestHeaders(request);
    }
    return request;
  }

  private setRequestHeadersWithNewTokens(request: HttpRequest<any>): HttpRequest<any> {
    return this.setRequestHeaders(request);
  }

  private setRequestHeaders(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        authorization: `Bearer ${this.loginService.agentAccessToken}`
      }
    });
  }

  private checkResponseErrors(error: HttpEvent<any>) {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 0:
        case 401:
          this.loginService.onLogout();
          this.redirectUser();
          break;
        case 403:
          this.redirectUser();
          break;
      }
    }
  }

  private redirectUser() {
    const extractedUrl = this.router.getCurrentNavigation()?.extractedUrl;
    const importLifePlanId = extractedUrl?.queryParams.import;
    if (importLifePlanId) {
      this.router.navigateByUrl(`/login?import=${importLifePlanId}`);
    } else {
      this.router.navigateByUrl('/login');
    }
  }
}
